import { useState, useEffect, useCallback, useMemo } from "react";
import { fetchUnits, deleteUnit } from "../services/unitService";
import { getLowerCaseString } from "../helpers/function";
import { verifyTokenExpire } from "../middleware/verifyToken";

export const useUnits = (endPoint) => {
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const loadUnits = useCallback(async () => {
    if (!verifyTokenExpire()) return;

    setLoading(true);
    try {
      const data = await fetchUnits(endPoint);
      setUnits(data);
    } catch (error) {
      console.error("Error fetching units:", error);
    } finally {
      setLoading(false);
    }
  }, [endPoint]);

  useEffect(() => {
    loadUnits();
  }, [loadUnits]);

  const filteredUnits = useMemo(() => {
    if (!searchTerm) return units;

    const term = getLowerCaseString(searchTerm);
    return units.filter(
      (unit) => 
          getLowerCaseString(unit.name.fr).indexOf(term) >= 0 ||
          //getLowerCaseString(unit.unit_type.name.fr).indexOf(term) >= 0 ||
          getLowerCaseString(
            unit.lead
              ? unit.lead.identite
                ? unit.lead.identite.lastname + " " + unit.lead.identite.firstname
                : "-"
              : "-"
          ).indexOf(term) >= 0
    );
  }, [units, searchTerm]);


  const removeUnit = useCallback(
    async (unitId) => {
      if (!verifyTokenExpire()) return false;
      try {
        await deleteUnit(endPoint, unitId);
        setUnits((prevUnits) => prevUnits.filter((unit) => unit.id !== unitId));
        return true;
      } catch (error) {
        console.error("Error deleting unit:", error);
        return false;
      }
    },
    [endPoint]
  );

  return {
    units,
    filteredUnits,
    loading,
    searchTerm,
    setSearchTerm,
    removeUnit,
    refresh: loadUnits,
  };
};
